/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WarningIcon from "../../assets/icons/WarningIcon";
import {
  useUploadAdditionDeductionSalaryMutation,
  useUploadVariableSalaryMutation,
} from "../../features/payrollSetting/payrollSettingApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { toast } from "../../lib/toast";
import { ModalComponentProps } from "../../types";
import Uploader from "../common/Uploader";
import SuccessModal from "../Report/SuccessModal";
import CustomModal from "../ui/CustomModal";

type Props = {
  handleConfirm: () => void;
} & ModalComponentProps;

export default function UpdateSalaryModal({ handleConfirm, ...rest }: Props) {
  const navigate = useNavigate();
  const [uploadVariableSalary, { isLoading, isError, error, isSuccess, data }] =
    useUploadVariableSalaryMutation();
  useError(isError, error, "Upload variable salary fail");
  const [
    uploadAdditionDeductionSalary,
    {
      isLoading: isAdditionDeductionLoading,
      isError: isAdditionDeductionError,
      error: additionDeductionError,
      isSuccess: isAdditionDeductionSuccess,
      data: additionDeductionData,
    },
  ] = useUploadAdditionDeductionSalaryMutation();
  useError(isError, error, "Upload variable salary fail");
  useError(
    isAdditionDeductionError,
    additionDeductionError,
    "Upload addition deduction salary fail"
  );
  const [formData, setFormData] = useState<FormData | null>(null);
  const [formData2, setFormData2] = useState<FormData | null>(null);

  const { handleOpen, open, handleClose } = useModal<undefined, "SUCCESS">();

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Variable salary uploaded successfully");
      handleOpen({ type: "SUCCESS" });
      // if (data?.data?.success === "success") {
      //   navigate("/admin/task-queue");
      // }
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isAdditionDeductionSuccess) {
      toast("success", "Addition deduction salary uploaded successfully");
      handleOpen({ type: "SUCCESS" });
      // if (additionDeductionData?.data?.success === "success") {
      //   navigate("/admin/task-queue");
      // }
    }
  }, [isAdditionDeductionSuccess]);

  return (
    <>
      <CustomModal
        {...rest}
        //   width={800}
        title="Upload Excel"
        className="salary-upload"
        footer={
          <div className="flex items-center">
            {open?.type === "SUCCESS" && (
              <SuccessModal
                type="queue"
                open={open?.open}
                handleClose={handleClose}
                handleOk={handleClose}
                isNavigate
              />
            )}

            <Button
              className="modal-button"
              type="primary"
              onClick={handleConfirm}
              disabled={!isSuccess && !isAdditionDeductionSuccess}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <div className="flex items-center gap-2 mb-6">
          <div className="flex-1 w-[200px]">
            <Uploader
              handler={setFormData}
              accept=".csv,.xls,.xlsx"
              downloadLink="/sample-variable-salary.xlsx"
              isLoading={isLoading}
              label="Select a .csv/.xls/.xlsx file for variable salary"
              className="!my-0"
              labelClass="!text-xs"
            />
          </div>
          <Button
            className="modal-button"
            type="primary"
            loading={isLoading}
            onClick={() => uploadVariableSalary(formData)}
          >
            Upload
          </Button>
        </div>

        <div className="flex items-center gap-2">
          <div className="flex-1 w-[200px]">
            <Uploader
              handler={setFormData2}
              accept=".csv,.xls,.xlsx"
              downloadLink={"/sample-addition-deduction-salary.xlsx"}
              isLoading={isAdditionDeductionLoading}
              label="Select a .csv/.xls/.xlsx file for addition deduction salary"
              className="!my-0"
              labelClass="!text-xs"
            />
          </div>
          <Button
            className="modal-button"
            type="primary"
            loading={isAdditionDeductionLoading}
            onClick={() => uploadAdditionDeductionSalary(formData2)}
          >
            Upload
          </Button>
        </div>

        <div className="flex gap-1.5 p-4 bg-[#fff4f4] rounded-md items-center mt-6">
          <div className="text-dark-highlight">
            <WarningIcon />
          </div>
          <div className="flex-1 text-display-body text-sm leading-relaxed">
            Please enter the year as a four-digit number (e.g., 2025, 2024) and
            the month as a number (e.g., 1 for January, 12 for December).
          </div>
        </div>
      </CustomModal>
    </>
  );
}
